export default __webpack_public_path__ + "static/hp-brand-deck-10-1299f578aea6f15a0a2208ce0ecf5e71.png";